import { put } from '..';
import { HappyScoreCategory } from '../../constants/Types';

const updateNotificationPreferences = (
  energy: boolean,
  internal: boolean,
  external: boolean,
  occupancy: boolean,
  amenities: boolean,
  it: boolean,
  ergonomics: boolean,
  satisfaction: boolean,
  happy: boolean,
) => {
  const enabledCategories = {};
  enabledCategories[HappyScoreCategory.ENERGY] = energy;
  enabledCategories[HappyScoreCategory.INTERNAL_ENVIRONMENT] = internal;
  enabledCategories[HappyScoreCategory.EXTERNAL_ENVIRONMENT] = external;
  enabledCategories[HappyScoreCategory.OCCUPANCY] = occupancy;
  enabledCategories[HappyScoreCategory.AMENITIES] = amenities;
  enabledCategories[HappyScoreCategory.IT] = it;
  enabledCategories[HappyScoreCategory.ERGONOMICS] = ergonomics;
  enabledCategories[HappyScoreCategory.SATISFACTION] = satisfaction;
  enabledCategories[HappyScoreCategory.HAPPY_SCORE] = happy;

  return put('users/me/notification-preferences', { enabledCategories });
};

export default updateNotificationPreferences;
